module.exports = __webpack_public_path__ + "img/f8da0add730d499984dc45971c52cc34.png";